import { LazyQueryHookOptions } from '@apollo/client';

import {
  PromoCodeGroupDownloadLinkQuery,
  PromoCodeGroupDownloadLinkQueryVariables,
  usePromoCodeGroupDownloadLinkLazyQuery,
} from '@occc/graphql';
import { useLazyQuery } from '@occc-app/dataAccessLayer/utils';

export const usePromoCodeGroupDownloadLink = (
  baseOptions?: LazyQueryHookOptions<
    PromoCodeGroupDownloadLinkQuery,
    PromoCodeGroupDownloadLinkQueryVariables
  >,
) => useLazyQuery(usePromoCodeGroupDownloadLinkLazyQuery, baseOptions);
